export const locale = {
    id: 'lv-LV',
    prefix: '',
    mailDomain: 'lv',
};
